import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { useT } from "../lib/i18n";
import { initAnalytics } from "../lib/analytics";
import { Button } from "./ui/button";

const KEY = "wa.cookie-consent";

export const CookieConsent = () => {
  const { t } = useT();
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(KEY);
      if (!stored) setShow(true);
      else if (stored === "all") initAnalytics();
    } catch (e) {
      console.warn("Cookie-voorkeur lezen mislukt:", e);
    }
  }, []);

  const decide = (value) => {
    try {
      localStorage.setItem(KEY, value);
    } catch (e) {
      console.warn("Cookie-voorkeur opslaan mislukt:", e);
    }
    if (value === "all") initAnalytics();
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 p-4 sm:p-6" data-testid="cookie-consent">
      <div className="mx-auto flex max-w-3xl flex-col gap-4 rounded-2xl border border-border bg-white p-5 shadow-2xl sm:flex-row sm:items-center">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-brandblue-light text-brandblue">
          <Cookie size={20} />
        </span>
        <p className="flex-1 text-sm text-slate-600">
          {t("cookie.text")}{" "}
          <Link to="/cookiebeleid" className="font-semibold text-brandblue underline-offset-2 hover:underline">
            {t("cookie.link")}
          </Link>
        </p>
        <div className="flex gap-2">
          <Button variant="outline" className="rounded-xl" onClick={() => decide("necessary")} data-testid="cookie-reject">
            {t("cookie.reject")}
          </Button>
          <Button className="rounded-xl bg-brandblue hover:bg-brandblue/90" onClick={() => decide("all")} data-testid="cookie-accept">
            {t("cookie.accept")}
          </Button>
        </div>
      </div>
    </div>
  );
};
